export enum EnumTipoCicloFacturacion {
  Cuentas = 1,
  Trades,
  Flexibilidad,
  Producto
}
